import { Link } from "react-router-dom";

export default function Cta() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20comic%20panel%20art%20background%20with%20warm%20coral%20amber%20gradient%20and%20soft%20light%20rays%2C%20stylized%20manga%20texture%2C%20clean%20minimal%20composition%2C%20warm%20inviting%20atmosphere%2C%20high%20detail%20illustration&width=1600&height=700&seq=home-cta&orientation=landscape"
        alt="漫画岛开始阅读背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/40"></div>

      <div className="container-site relative z-10 w-full py-20 text-center md:py-24">
        <h2 className="font-heading text-3xl text-white md:text-4xl">
          现在就开启你的漫画之旅
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">
          高清原图、横屏观看、夜间模式、舒适翻页——漫画岛为你准备了一切,只管享受每一格画面。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category/all"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto cursor-pointer"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-8 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}